import { TextInputIcon, Trash03Icon } from "@gohighlevel/ghl-icons/24/outline";
import { computed, h } from "vue";

import { i18n } from "@/plugin/vue-i18n";

// UIDropdown does not forward attrs and the menu is teleported, so scoped CSS cannot reach
// it: per-option props (applied by naive to each item) carry the spacing instead.
const ITEM_STYLE = Object.freeze({
  minWidth: "160px",
  paddingLeft: "12px",
  paddingRight: "12px",
  columnGap: "8px",
});
const DESTRUCTIVE_COLOR = "var(--error-600, #d92d20)";
const DESTRUCTIVE_ITEM_STYLE = Object.freeze({ ...ITEM_STYLE, color: DESTRUCTIVE_COLOR });

const renameIcon = () => h(TextInputIcon, { class: "h-4 w-4" });
const deleteIcon = () => h(Trash03Icon, { class: "h-4 w-4", style: { color: DESTRUCTIVE_COLOR } });

/** Menu order; the item ids let the kebab point aria-activedescendant at the highlighted one */
export const WORKFLOW_ACTION_KEYS = ["rename", "delete"] as const;
export const workflowActionItemId = (key: (typeof WORKFLOW_ACTION_KEYS)[number]) =>
  `wf-action-${key}`;

/**
 * Kebab menu options for a linked workflow row, built once for every row and rebuilt only
 * when the locale changes. Only one menu is open at a time, so the item ids stay unique.
 */
export const workflowActionOptions = computed(() => [
  {
    key: "rename",
    label: i18n.global.t("common.rename"),
    icon: renameIcon,
    props: { style: ITEM_STYLE, role: "menuitem", id: workflowActionItemId("rename") },
  },
  {
    key: "delete",
    label: i18n.global.t("common.delete"),
    icon: deleteIcon,
    props: { style: DESTRUCTIVE_ITEM_STYLE, role: "menuitem", id: workflowActionItemId("delete") },
  },
]);
